 <div class="ag-media-gallery__deleting" *ngIf="isDeletingSig()">
  <dx-load-indicator></dx-load-indicator>
</div>

<div class="image-gallery__empty" *ngIf="!mediaItems?.length; else imageGalleryTmp">
  <i class="dx-icon-agi-picture image-gallery__empty--icon"></i>
  <p class="image-gallery__empty--text">No Elements</p>
</div>

<ng-template #imageGalleryTmp>
  <div class="ag-media-gallery__select-actions">
    <div *ngIf="multipleSelection" class="ag-media-gallery__select-actions--select-all">
      <dx-button
        class="rounded-button"
        [icon]="isAllSelected ? 'check' : ''"
        [stylingMode]="'outlined'"
        [type]="'default'"
        [width]="25"
        [height]="25"
        [useSubmitBehavior]="false"
        (onClick)="selectAll()"
      >
      </dx-button>
      Select All
    </div>

    <div *ngIf="allowActions" class="ag-media-gallery__select-actions--actions">
      <shr-button-with-indicator
        class="ag-media-gallery__select-actions--actions-button"
        (onClick)="downloadSelectedImages()"
        [stylingMode]="'outlined'"
        [title]="'Download'"
        [icon]="'download'"
        [disabled]="_selectedItems.size === 0"
      ></shr-button-with-indicator>
      <!-- <shr-button-with-indicator -->
      <!-- class="select-actions__actions&#45;&#45;button" -->
      <!-- (onClick)="setPrimarySelectedImages()" -->
      <!-- [stylingMode]="'outlined'" -->
      <!-- [disabled]="_selectedItems.size !== 1" -->
      <!-- [title]="'Set as Primary'" -->
      <!-- ></shr-button-with-indicator> -->
    </div>
  </div>
  <dx-scroll-view class="image-scroll-view" [direction]="'vertical'" [showScrollbar]="'onHover'">
    <div class="image-gallery">
      <div class="image-grid">
        <div
          class="image-item"
          [class.selected]="_selectedItems.has(image)"
          (click)="toggleImageSelection(image, $event)"
          *ngFor="let image of mediaItems; trackBy: trackByMediaId"
        >
          <ag-shr-image-with-loader
            class="ag-media-gallery__image"
            [wasabiPath]="image?.[AGMediaKeys.wasabiPath]"
            [mediaSize]="MediaSize.large"
          ></ag-shr-image-with-loader>

          <div *ngIf="allowZoomIn" class="zoom-icon" (click)="stopPropagation($event)">
            <dx-button
              stylingMode="text"
              icon="agi-zoom-in"
              (onClick)="zoomImage(image)"
              [elementAttr]="{
                class: 'image-item-zoom-button',
              }"
            ></dx-button>
          </div>

          <div class="selector-circle" [class.selected]="_selectedItems.has(image)"></div>

          <div class="image-info-row">
            <div class="file-name-container">
              <div class="file-name-content">{{ image?.[AGMediaKeys.fileName] }}</div>
            </div>
            <div *ngIf="allowActions" class="image-options" (click)="stopPropagation($event)">
              <dx-drop-down-button
                class="image-options__button"
                [showArrowIcon]="false"
                [dropDownOptions]="{ width: 230 }"
                (onItemClick)="logAction($event, image)"
                icon="overflow"
                stylingMode="text"
                [items]="editOptions"
                [useItemTextAsTitle]="false"
              >
              </dx-drop-down-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </dx-scroll-view>
</ng-template>

<ag-shr-modal-window
  #fullScreenImg
  [width]="'100vw'"
  [height]="'100vh'"
  [showSaveButton]="false"
  [useScrollView]="false"
  (onHidden)="fullScreenImgUrl$.next(null)"
>
  <img class="image-gallery__full-size-image" [src]="fullScreenImgUrl$ | async | wasabiImg" alt="Image" />
</ag-shr-modal-window>

<ag-shr-modal-window
  #renamePopup
  [title]="'Rename file'"
  (onSaveClick)="renameMedia()"
  (onHidden)="clearRenamePopup()"
  [width]="360"
  [height]="225"
  [showCloseButton]="true"
  [saveButtonDisabled]="!isMediaNameValidSig()"
>
  <div class="popup-content">
    <dx-text-box [value]="mediaNameSig()" (valueChange)="mediaNameSig.set($event)" [showClearButton]="true" [width]="310">
      <dx-validator>
        <dxi-validation-rule type="required" message="Name is required"></dxi-validation-rule>
        <dxi-validation-rule
          type="custom"
          [validationCallback]="validateUniqueName"
          message="File with this name already exists"
        ></dxi-validation-rule>
        <dxi-validation-rule
          type="stringLength"
          [min]="1"
          [max]="255"
          message="Name should be between 1 and 255 characters"
        ></dxi-validation-rule>
      </dx-validator>
    </dx-text-box>
  </div>
</ag-shr-modal-window>
